import React from 'react';
import { Box } from '@mui/material';
import OwnerReservationsPage from './OwnerReservationsPage';

/**
 * Page autonome pour les réservations propriétaire
 * Vue directe sans wrapper complexe
 */
const OwnerReservationsStandalonePage = () => {
  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 230px)',
      position: 'relative',
      paddingBottom: '20px',
      display: 'flex', 
      flexDirection: 'column'
    }}>
      <Box sx={{ flexGrow: 1 }}>
        <OwnerReservationsPage key="owner-reservations" embedded={false} />
      </Box>
    </Box>
  );
};

export default OwnerReservationsStandalonePage;
